<template>
    <main class="pt-3 pb-0">
        <v-dialog v-model="isLoading" width="200" persistent no-click-animation>
            <div class="modalContainer">
                <div class="loadingWrapper py-8 text-center">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <p class="mt-4 text-center">Loading...</p>
                </div>
            </div>
        </v-dialog>

        <div class="campaignWrapper thankyouBg" v-if="!isLoading">
            <div class="campaignDataForm thankyouMsg">
                <div class="formWrapper">
                    <div class="py-6">
                        <p class="formHeader">{{ campaignThankTitle }}</p>
                        <p class="formSubHeader" v-html="campaignThankBody"></p>
                    </div>
                    <div class="disclamer">
                        <p>Your information is held in the strictest of confidence as indicated in our <a href="https://www.scmp.com/privacy-policy" target="_blank">privacy policy</a> and <a href="https://www.scmp.com/terms-conditions" target="_blank">online service agreement</a>. Our procedures have been designed to safeguard your personal data and ensure secure transactions.</p>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ThankYou',
    data() {
        return {
            isLoading: true,
            campaignThankTitle: "",
            campaignThankBody: ""
        };
    },
    mounted() {
        let vm = this,
            campaign_id = vm.$route.params.campaign_id;

        axios.post(process.env.VUE_APP_API_PATH + "/campaign/" + campaign_id)
            .then(response => {
                const campaignRes = response.data.output[0];
                vm.campaignThankTitle = campaignRes.campaign_thank_title
                vm.campaignThankBody = campaignRes.campaign_thank_body
                vm.isLoading = false
            })
            .catch(error => {
                console.log(error)
            })
    }
}
</script>
